import { CognitoIdentityServiceProvider } from 'aws-sdk';

export var mapperMultiAdressCodes = function mapperMultiAdressCodes(codes, type) {
    console.log(">>>>>ENTRO CON ", codes);
    var newArray = [];
    if (type === 'soles') {
        codes.forEach(function (element) {
            if (element.moneda.toLowerCase() == 'soles' && element.codigo.length > 0 && element.codigo != 0 && element.codigo !== 'FAILED') {
                newArray.push({
                    codigo: element.codigo,
                    isUpload: 0
                });
            }
        });
    } else {
        codes.forEach(function (element) {
            if (element.moneda.toLowerCase() == 'dolares' && element.codigo.length > 0 && element.codigo != 0 && element.codigo !== 'FAILED') {
                newArray.push({
                    codigo: element.codigo,
                    isUpload: 0
                });
            }
        });
    }
    console.log("Array", newArray);
    return newArray;
};


//////////////////
// WEBPACK FOOTER
// ./src/mappers/requestCodes.js
// module id = ./src/mappers/requestCodes.js
// module chunks = 34